import { useCallback } from 'react';
import { DateInput, FormFieldsData, ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { useNewProjectService } from 'domain/shared/newProject';
import { ProjectManagementHealthcheckModalProps } from './types';

const ForecastCompletionDateUpdateModal = ({
  data,
  isOpen,
  onClose,
  refetchControlsData,
}: ProjectManagementHealthcheckModalProps) => {
  const { putProjectTimelineForecast, forecastCompletionDateValidationSchema } = useNewProjectService();

  const submitFormFunc = useCallback(
    async (stateData: FormFieldsData) => {
      const updatedForecastData = {
        forecastCompletionDate: stateData.forecast?.forecastCompletionDate,
      };
      return putProjectTimelineForecast(data.id, updatedForecastData);
    },
    [putProjectTimelineForecast, data.id],
  );

  return (
    <Modal
      isOpen={isOpen}
      onToggle={onClose}
      title="Forecast completion date"
      paperStyles={{ background: 'var(--mui-palette-background-paper)' }}
    >
      <ModalForm
        closeModal={onClose}
        modalOpen={isOpen}
        submitFormFunc={submitFormFunc}
        getValidationSchemaFunc={forecastCompletionDateValidationSchema}
        afterSubmit={{ execute: () => refetchControlsData() }}
        getDataFunc={async () => data}
      >
        <DateInput
          source="forecast.forecastCompletionDate"
          label="Forecast Completion Date"
          maxDate={data.budget?.extendedEndDate}
        />
      </ModalForm>
    </Modal>
  );
};

export default ForecastCompletionDateUpdateModal;
